import React from 'react';
import ModalModule from '../modal';
import MarketingButton from './MarketingButton.component';

const { Modal } = ModalModule;

/*
 * This component does not generate its buttons through the primaryButton/secondaryButton prop.
 * Instead, it reuses MarketingButton which is also shared with the MarketingBanner component.
 */
const MarketingModal = ({ modalId, data: { campaign, triggerCampaignAction } }) => {
	const {
		ShowPrimaryButton,
		PrimaryButtonColor,
		PrimaryButtonHoverColor,
		PrimaryButtonText,
		PrimaryButtonTextColor,
		ShowSecondaryButton,
		SecondaryButtonColor,
		SecondaryButtonHoverColor,
		SecondaryButtonText,
		SecondaryButtonTextColor,
		Title,
		ImageUrl,
	} = campaign;

	const hideFooterCls = !ShowPrimaryButton && !ShowSecondaryButton ? ' hide-footer' : '';

	return (
		<Modal
			modalId={modalId}
			className="common-marketing marketing-modal"
			header={Title}
			hideFooter
			onCloseButtonClick={triggerCampaignAction}
		>
			<div className="body">
				<img className="banner-image" src={ImageUrl} alt="marketing modal" />
			</div>
			<div className={`p-dialog-footer${hideFooterCls}`}>
				{ShowPrimaryButton && (
					<MarketingButton
						buttonType="primary"
						buttonColor={PrimaryButtonColor}
						buttonHoverColor={PrimaryButtonHoverColor}
						buttonText={PrimaryButtonText}
						buttonTextColor={PrimaryButtonTextColor}
						triggerCampaignAction={triggerCampaignAction}
					/>
				)}
				{ShowSecondaryButton && (
					<MarketingButton
						buttonType="secondary"
						buttonColor={SecondaryButtonColor}
						buttonHoverColor={SecondaryButtonHoverColor}
						buttonText={SecondaryButtonText}
						buttonTextColor={SecondaryButtonTextColor}
						triggerCampaignAction={triggerCampaignAction}
					/>
				)}
			</div>
		</Modal>
	);
};

export default MarketingModal;
